import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../../i18n/i18n";
import "./Footer.css";

export default function Footer() {
  const { t, i18n } = useTranslation("common");
  const isRTL = i18n.language === "ar";

  const toggleLang = async () => {
    await setLanguage(isRTL ? "en" : "ar");
  };

  return (
    <footer className={`footer ${isRTL ? "footer--rtl" : ""}`}>
      <div className="footer__card">
        <div className="footer__container">

          {/* Column 1 */}
          <div className="footer__col">
            <h3 className="footer__title">{t("footer.about.title")}</h3>
            <NavLink to="/">{t("footer.about.home")}</NavLink>
            <NavLink to="/about">{t("footer.about.about")}</NavLink>
            <NavLink to="/investments">{t("footer.about.investments")}</NavLink>
            <NavLink to="/contact">{t("footer.about.contact")}</NavLink>
          </div>

          {/* Column 2 */}
          <div className="footer__col">
            <h3 className="footer__title">{t("footer.mediaGovernance.title")}</h3>
            <div className="footer__sub">
              <NavLink to="/media-center">{t("footer.mediaGovernance.mediaCenter")}</NavLink>
              <NavLink to="/governance/policies">{t("footer.mediaGovernance.policies")}</NavLink>
              <NavLink to="/governance/board-minutes">{t("footer.mediaGovernance.boardMinutes")}</NavLink>
              <NavLink to="/governance/regulations">{t("footer.mediaGovernance.regulations")}</NavLink>
              <NavLink to="/governance/financial-statements">{t("footer.mediaGovernance.financialStatements")}</NavLink>
              <NavLink to="/governance/annual-reports">{t("footer.mediaGovernance.annualReports")}</NavLink>
            </div>
          </div>

          {/* Column 3 */}
          <div className="footer__col">
            <h3 className="footer__title">{t("footer.management.title")}</h3>
            <div className="footer__sub">
              <NavLink to="/management/board">{t("footer.management.board")}</NavLink>
              <NavLink to="/management/ceo">{t("footer.management.ceo")}</NavLink>
              <NavLink to="/management/org-structure">{t("footer.management.orgStructure")}</NavLink>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer__bottom">
          <div className="footer__social">
            <a href="https://x.com/Tarhal_sa" target="_blank" rel="noreferrer">
              {t("footer.social.x")}
            </a>
            <a href="https://www.instagram.com/trhal.sa" target="_blank" rel="noreferrer">
              {t("footer.social.instagram")}
            </a>
            <a
              href="https://api.whatsapp.com/send/?phone=966535531261&text&type=phone_number&app_absent=0"
              target="_blank"
              rel="noreferrer"
            >
              {t("footer.social.whatsapp")}
            </a>
          </div>

          <img src="/brand/logo.png" alt="Terhal Logo" className="footer__logo" />

          <button className="footer__lang" onClick={toggleLang}>
            {isRTL ? t("footer.lang.en") : t("footer.lang.ar")}
          </button>
        </div>

        <p className="footer__copyright">
          {t("footer.copyright", { year: new Date().getFullYear() })}
        </p>
      </div>
    </footer>
  );
}
